<script setup lang="ts">
import {HomeSharingItem} from "@/home/interfaces";
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import SharingRequestDialog from "@/sharing/components/sharing-request-dialog/SharingRequestDialog.vue";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{
    item: HomeSharingItem['data']
}>();
</script>

<template>
  <SharingRequestDialog :sharing="item" :show-see-data="true">
    <HomeLiveItem
      :at="item.created_at"
      bg-color-class="bg-red-light hover:bg-red-light/50 text-white"
    >
      <template #image>
        <div v-if="item.tenant.hospital?.logo" class="bg-white rounded-lg shadow-md overflow-hidden">
          <img :src="item.tenant.hospital.logo?.url" alt="logo">
        </div>
        <div v-else class="relative bg-white p-2 rounded-full">
          <Icon name="mdi-hospital-building" class="absolute" color="primary" :size="20" />
        </div>
      </template>
      <p class="text-sm font-bold">
        {{ item.sharable.information?.name }}
      </p>
      <p>Conciliation médicamenteuse</p>
    </HomeLiveItem>
  </SharingRequestDialog>
</template>

<style scoped>

</style>
